// extracted by mini-css-extract-plugin
module.exports = {"loader":"ch","smallLoader":"dh","loading-keyframes":"eh","pageLoader":"fh","centered":"gh","whitespacePlaceholder":"hh","buttonSpinner":"ih","fade-in":"jh","rotate":"kh"};